module.exports = "pegasus/assets/themelp1/simple/100.png";